<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      :searchable="false"
      :filters="filters"
      :selectable="false"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader>
        <b-col>
          <b-form-group
            :label="$t('general.user')"
          >
            <v-select-custom
              v-model="userId"
              :options="userOptions"
              :custom-props="{ label: 'fullName' }"
              @open="fetchUsersByRole({ role: 'user' })"
              @search="fetchUsersByRole({ role: 'user', 'search' : $event })"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            :label="$t('general.consultant')"
          >
            <v-select-custom
              v-model="consultantId"
              :options="userOptions"
              :custom-props="{ label: 'fullName' }"
              @search="fetchUsersByRole({role:'consultant' , 'search' :$event})"
              @open="fetchUsersByRole({role:'consultant'})"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            :label="$t('general.noResponseDays')"
          >
            <v-select-custom
              v-model="idleDays"
              :options="Array( 10).fill().map((_, idx) =>1+ idx)"
            />
          </b-form-group>
        </b-col>
      </template>

      <!-- Column: status -->
      <template #cell(status)="{ item }">
        <pill-icon-cell
          :status="$t(`counselings.${item.status}`)"
          :options="statusOptions"
        />
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row
          v-if="isViewable('update', 'counseling')"
          @click.native="toEditPage(item._id)"
        />
        <!-- <delete-row v-if="isViewable('delete', 'counseling')" @click.native="deleteItem(item._id)" /> -->
        <view-row
          v-if="isViewable('create', 'counseling')"
          :class="item.viewConsultIds.length === 0 ? 'eyeColor' : ' '"
          @click.native="$router.push({name: `pages-counseling-messages`,params: { id: item._id } })"
        />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import { BCol, BFormGroup } from 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import '@/components/BMediaCustom/index.vue'
import '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import ViewRow from '@/components/BDataTable/Actions/ViewRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import PillIconCell from '@/components/BDataTable/Elements/PillIconCell.vue'
import VSelectCustom from '@/components/VSelectCustom/index.vue'
import useCounselingsList from './useCounselingsList'

export default {
  name: 'CounselingsList',
  components: {
    BCol,
    BDataTable,
    BFormGroup,
    EditRow,
    LayoutLoading,
    PillIconCell,
    VSelectCustom,
    ViewRow,
  },
  setup() {
    const {
      deleteItem,
      fetchList,
      fetchUsersByRole,
      groupDelete,
      isSubmit,
      isViewable,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
      userOptions,
    } = useCounselingsList('counseling/counseling-report')
    return {
      deleteItem,
      fetchList,
      fetchUsersByRole,
      groupDelete,
      isSubmit,
      isViewable,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
      userOptions,
    }
  },
  data() {
    return {
      consultantOptions: [],
      consultantId: null,
      userId: null,
      idleDays: 0,
    }
  },
  computed: {
    filters() {
      return {
        consultantId: this.consultantId && this.consultantId._id,
        userId: this.userId && this.userId._id,
        idleDays: this.idleDays,
      }
    },
  },
  watch: {
    consultantId() {
      this.refTable.refetchData()
    },
    userId() {
      this.refTable.refetchData()
    },
    idleDays() {
      this.refTable.refetchData()
    },
  },
  created() {
    this.fetchUsersByRole({
      role: 'consultant',
    }).then(res => {
      this.consultantOptions = res
    })
    this.fetchUsersByRole({
      role: 'user',
    }).then(res => {
      this.userOptions = res
    })
  },
  methods: {
    searchConsultant(search) {
      this.fetchUsersByRole({
        role: 'consultant',
        search,
      }).then(res => {
        this.consultantOptions = res
      })
    },
    searchUser(search) {
      this.fetchUsersByRole({
        role: 'user',
        search,
      }).then(res => {
        this.userOptions = res
      })
    },
  },
}
</script>

<style scoped>
.eyeColor{
  fill: #6ad38c !important;
  opacity: 1 !important;
}
@media (max-width : 1199px){
  .feather-edit{
    margin-bottom: 20px;
    margin-right: 1rem !important;

}
}
</style>
